export default function SvgVolumeOn2() {
    return (
      <>
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      fill="#fff"
      viewBox="0 0 24 24"
    >
      <path d="M11.193 4.452L5.67 9H2.376A1.376 1.376 0 001 10.376v3.248A1.376 1.376 0 002.376 15h3.293l5.524 4.548a.51.51 0 00.807-.414V4.866a.51.51 0 00-.807-.414zM11 18.088L6.028 14H2.375A.375.375 0 012 13.625v-3.25A.375.375 0 012.375 10h3.653L11 5.911zm4.47-12.744A9.975 9.975 0 0118 11.987a9.848 9.848 0 01-2.566 6.646l-.74-.672A8.872 8.872 0 0017 11.987a8.984 8.984 0 00-2.277-5.978zm3.46-3.933A15.817 15.817 0 0123 11.989a15.945 15.945 0 01-4.035 10.576l-.735-.65A14.966 14.966 0 0022 11.988a14.852 14.852 0 00-3.8-9.924z"></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </svg>
    </>
    );
  }
